export const REFRESH_DASHBOARD = 'DASHBOARD:REFRESH';
export const STOP_REFRESH_DASHBOARD = 'DASHBOARD_REFRESH:STOP';
export const LOAD_SNAPSHOT = 'SNAPSHOT:LOAD';
export const SET_DEVICE_TYPE = 'DEVICE_TYPE:SET';
export const SET_SERVICE_TYPE = 'SERVICE_TYPE:SET';
export const SET_TIME_RANGE = 'TIME_RANGE:SET';
export const REFRESH_DATA = 'DATA:REFRESH';
export const REFRESH_SNAPSHOT = 'SNAPSHOT:REFRESH';
export const SET_DASHBOARD_V2_DATE_RANGE = 'DASHBOARD_V2:SET_DATE_RANGE';
